// extracted by mini-css-extract-plugin
export var header = "_sh-1";
export var maskBottom = "_sh-6";
export var maskMiddle = "_sh-7";
export var maskTop = "_sh-5";
export var root = "_sh-0";
export var scrollDownButton = "_sh-3";
export var scrollDownButtonHidden = "_sh-4";
export var viewport = "_sh-2";